import React, { useEffect, useRef, useState } from "react";
import StaticTypeWriterWithParser from "./StatictTypeWritingEffect/StaticTypeWriterWithParser";
import StaticTypeWriter from "./StatictTypeWritingEffect/StaticTypeWriter";
import StaticFooter from "./StaticFooter";
import { staticHeader } from "../../Services/CommonServices/helper";

const BronxTale = () => {
  const [isTitle, setIsTitle] = useState(false);
  const [isProductTitle, setIsProductTitle] = useState(false);
  const [isProductDescription, setIsproductDescription] = useState(false);
  const [isSecondProductTitle, setIsSecondProductTitle] = useState(false);
  const [isSecondProductDescription, setIsSecondProductDescription] = useState(false);
  const [downArrow, setShowDownArrow] = useState(false);
  const effects = false;
  const titleHeader = "A Bronx Tale"
  const subheader = "How a small drawer full of wide ties led to an empire of American style"
  const effectRan = useRef(false);

  useEffect(() => {
    if (!effectRan.current) {
      staticHeader(titleHeader, 'titleHeader')
    }
    staticHeader(subheader, 'subHeaderContainer')
    return () => effectRan.current = true;
  },  [isTitle])


  // scroll to bottom arrow functionality
  useEffect(() => {
    const pageContainer = document.getElementById('styleGuidePageContainer');
    if (!pageContainer) return;

    let initialViewportHeight = pageContainer.clientHeight;
    const handleScroll = () => {
      const overflownspace = pageContainer.scrollHeight - pageContainer.scrollTop - pageContainer.clientHeight;      
      if (overflownspace > initialViewportHeight * 0.1) {        
        setShowDownArrow(true);
      } else {
        setShowDownArrow(false);
      }
      return;
    };

    const observer = new MutationObserver(() => {
      setTimeout(handleScroll, 100);
    });
    observer.observe(pageContainer, { childList: true, subtree: true });
    pageContainer.addEventListener('scroll', handleScroll);
    handleScroll();
    setTimeout(handleScroll, 300);
    return () => {
      pageContainer.removeEventListener('scroll', handleScroll);
      setShowDownArrow(false);
      observer.disconnect();
    }
  }, []);

  const scrollToEnd = () => {
    const pageContainer = document.getElementById('styleGuidePageContainer');
    if (pageContainer) {
      pageContainer.scrollTo({
        top: pageContainer.scrollHeight - 100,
        behavior: 'smooth'
      });
      setShowDownArrow(false);
    }
  };

  const adjustDownArrowPosition = () => {
    const downArrowElement = document.querySelector('.down-arrow');

    if (downArrowElement) {
      downArrowElement.style.bottom = '15px';
      downArrowElement.style.left = '50%';
      downArrowElement.style.transform = 'translateX(-50%)';
    }
  };

  useEffect(() => {
    adjustDownArrowPosition();
    
    const handleResize = () => {
      adjustDownArrowPosition();
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [downArrow]);

  return (
    
    // Static Component without json data
    <div
      className="container p-0 art-of-bundling-up overflow"
      style={{ backgroundColor: "#EFEFEF" }}
       id="styleGuidePageContainer"
    >
      <div>
        <img
          src={"/static/assets/StaticLandingPageImages/Bronx-img1.png"}
          alt="top-img"
          className="top-img"
        />
      </div>
      <div className="content card align-items-center mb-0">
          <div>
          <div className="title" id="titleHeader">
            <div style={{display: "none"}}>
              <StaticTypeWriter text={"A Bronx Tale"} setLoading={setIsTitle}/>
            </div>
          </div>
          { isTitle && 
            <div className="subheader" id="subHeaderContainer">
              <div style={{display: "none"}}>
                <StaticTypeWriter text={"How a small drawer full of wide ties led to an empire of American style"} setLoading={() => {}}/>
              </div>
            </div>
          }
          <div className="carousel-polar-div">
          {/* { isDescription &&  */}
            <div className="rl-text">
              <StaticTypeWriter text={"By Ralph Lauren"} effects={effects} setLoading={() => {}}/>
            </div>
          {/* } */}
          {/* {
            isSubHeader &&  */}
            <div className="carousel-polar-div">
              <div>
                <div>
                  <div className="d-flex align-items-center justify-content-center">
                    <img
                      src="/static/assets/StaticLandingPageImages/Bronx-img2.png"
                      alt="img"
                    />
                  </div>
                  <div>
                    <div className="text-head">
                      <StaticTypeWriter text={"Cabinet of Curiosities"} effects={effects} setLoading={setIsProductTitle}/>
                    </div>
                    {
                      isProductTitle && 
                        <div className="text-description">
                          <StaticTypeWriter text={"From top, Ralph in the early 1970s as his tie business expanded to include shirts; a few examples of his first tie designs, which, as he writes, included “patterns, classic repp stripes, and prints”"} effects={effects} setLoading={setIsproductDescription}/>
                        </div>
                    }
                    {
                      isProductDescription && 
                        <div className="description" style={{ marginBottom: "40px" }}>
                          <StaticTypeWriterWithParser text={`<p>
                            Ricky and I had just gotten married, and we lived in the Bronx in a
                            one-bedroom apartment with a kitchen in the living room and—this is
                            not a joke—a train station that went right over us. We heard the El
                            at night. It was like Barefoot in the Park. We hung pictures we’d
                            torn from magazines on an inspiration board. We went to get
                            director’s chairs. Orange. Bright. Canvas. We went to the Lower East
                            Side and got antique furs and put them on the bed. We all build our
                            lives, and that’s what we were doing. We were dreaming, dreaming
                            about tomorrow,
                          </p>
                          <p>
                            It all started with ties, and I called the ties Polo. At the
                            time—this was 1967—I felt there was no tie like the ones I wanted to
                            do. My tie was wide at a time when men wore narrow ties, like today.
                            I searched for unusual fabrics, so they were unique. Men loved them.
                            They bounced off the racks.
                          </p>
                          <p>
                            I worked in a one-room office in the Empire State Building. I kept
                            all the ties in a drawer, one little drawer. Ricky and her mother
                            and father sewed on the labels, and I sold to the stores. I
                            delivered the orders myself in an old bomber jacket and jeans. I’d
                            hail a cab carrying a bag full of ties, until I was able to buy my
                            own car—a vintage Morgan, in which I made rounds with the top down.
                          </p>`} effects={effects} setLoading={() => {}} />
                        </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          {/* } */}
          </div>
          </div>
      </div>
      {/* {
        isProductContent && */}
        <div className="copy-txt carousel-polar-div">
          <div className="carousel-polar-div">
          <StaticTypeWriter text={`"It was understated, but, still, it was change—and the world was ready for it. Polo became an item. It became the Polo tie, the Polo look. I was beginning to move and change menswear in a simple way."`} effects={effects} setLoading={() => {}}/>
          <img
            src={"/static/assets/StaticLandingPageImages/sign.png"}
            alt="sign"
            className="sign"
          />
          </div>
        </div>
      {/* } */}
      {/* { isQuotes && */}
        <div className="content card align-items-center carousel-polar-div">
          <div style={{ marginBottom: "20px" }}>
            <img
              src="/static/assets/StaticLandingPageImages/Bronx-img3.png"
              alt="img"
            />
          </div>
          <div>
            <img
              src="/static/assets/StaticLandingPageImages/Bronx-img4.png"
              alt="img"
            />
          </div>
          <div className="text-head">
            <StaticTypeWriter text={"Street Style"} effects={effects} setLoading={setIsSecondProductTitle}/>
          </div>
          {
            isSecondProductTitle && 
              <div className="text-description">
                <StaticTypeWriter text={"From above, biking in Manhattan, 1976; uptown moves, an ad from the 1980s"} effects={effects} setLoading={setIsSecondProductDescription}/>
              </div>
          }
          {
              isSecondProductDescription && 
                <div className="description" style={{ marginBottom: "20px" }}>
                  <StaticTypeWriterWithParser text={`<p>
                    Back then, men of all ages wore ties, but they were used to them
                    being narrow. I thought the world was ready for a change, and I had
                    a vision based on what I wanted to look like and the things I
                    couldn’t find. I’d wanted a wide tie, so I made it. There’d been
                    wide ties before. The innovation was that I was making them from
                    unexpected fabrics—patterns, classic repp stripes, and prints. Then,
                    I needed a shirt made for a wide tie, and I wanted it to have a
                    spread collar.
                  </p>
                  <p>
                    The stores loved the ties and wanted more. They said, what else can
                    you do? I told them I could do shirts, suits. The lapels on a sport
                    coat and suit also had to be balanced to go with the width of my
                    ties. It was understated, but, still, it was change—and the world
                    was ready for it. Polo became an item. It became the Polo tie, the
                    Polo look. I was beginning to move and change menswear in a simple
                    way. And then I said I think I can do womenswear, children’s
                    clothes, home. Each new thing was an evolution of this one world,
                    which started with the wide tie.
                  </p>
                  <p>
                    It’s still amazing to me. I was just a kid from the Bronx with a
                    dream about a world I saw in my mind. I made things that I loved,
                    and, as it turned out, other people loved them, too.
                  </p>`} effects={effects} setLoading={() => {}} />
                </div>
            }
        </div>
      {/* } */}
      {/* { isSecondProductContent && */}
          <StaticFooter/>
      {/* } */}
            {downArrow && (
        <button
          className="down-arrow"
          onClick={scrollToEnd}
          style={{ 
            position: 'fixed',
            bottom: '44px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1001,
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <img
            alt="down-arrow"
            src="./static/assets/scrollDown.svg"
          />
        </button>
      )}
    </div>
  );
};

export default BronxTale;
